export const checkPhone = (phone: string) => {
  return /^1[3456789]\d{9}$/.test(phone);
};

export const checkCode = (code: string) => {
  return /^\d{6}$/.test(code);
};
